import { render } from "./saml.vue?vue&type=template&id=1af46082&scoped=true"
import script from "./saml.vue?vue&type=script&lang=js"
export * from "./saml.vue?vue&type=script&lang=js"

import "./saml.vue?vue&type=style&index=0&id=1af46082&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af46082"]])

export default __exports__